<template>
  <GlobalLoader />
  <router-view v-slot="{ Component }">
    <transition name="page" mode="out-in">
      <component :is="Component" />
    </transition>
  </router-view>
  <div id="toastContainer" class="toast-container"></div>
  <div id="customModal" class="modal-container hidden"></div>
  <div id="filePreviewModal" class="modal-container hidden" style="z-index: 1050;"></div>
</template>

<script setup>
import GlobalLoader from './components/ui/GlobalLoader.vue'
</script>
